const thresholdTypes = ['aluminium', 'dropdownseal'];

export default thresholdTypes;
